// extracted by mini-css-extract-plugin
export default {"link":"mAZF70It--EarlyCancellationFee_link__1MHOB","container":"mAZF70It--EarlyCancellationFee_container__IKopd"};